import React from "react";

import FormPrefixContext from "../contexts/FormPrefixContext";

const useFormPrefix = () => React.useContext(FormPrefixContext);

export default useFormPrefix;
